export const LOGIN_VALIDATION_RULE = {
  required: 'Поле логин обязательно к заполнению!',
  pattern: {
    value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    message: 'Введите, пожалуйста, корректный email',
  },
};

export const PASSWORD_VALIDATION_RULE = {
  required: 'Поле пароль обязательно к заполнению!',
  pattern: {
    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
    message: 'Неправильный пароль',
  },
};
